import { render, staticRenderFns } from "./edit-date.dialog.vue?vue&type=template&id=33defb4e&scoped=true"
import script from "./edit-date.dialog.vue?vue&type=script&lang=js"
export * from "./edit-date.dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33defb4e",
  null
  
)

export default component.exports